import type { SideCTA } from '@ps/web-martech-cms-types';
import React from 'react';

import { CMSCTA } from '@swf/cms';

const CMSSideCTA: React.FC<SideCTA> = ({ cta }) => <CMSCTA space={false} grow {...cta} />;

export default CMSSideCTA;
